interface ITestimonial {
  author: string
  quote: string
  title: string
}

export const testimonials: ITestimonial[] = [
  {
    author: '7 & 8th Grade Science Teacher',
    quote:
      "The students would not stop talking about what happened today [following an Industry Professional Videoconference Interaction] ... You could tell that they were thinking, 'I think I might want to be a STEM professional.'",
    title: '',
  },
  {
    author: 'Male Student',
    quote:
      'I would like to be a STEM Professional when I grow up because I love engineering and this interaction gives me an experience of engineering at a younger age, so I could get a head start.',
    title: '6th Grade',
  },
  {
    author: 'Female Student',
    quote:
      '... I have learned that science, technology, engineering and math are a massive part of our future lives. Thanks to the STEM professionals, I have also learned that science is what I want to base my future career on.',
    title: '8th Grade',
  },
]

export const randomTestimonial = () => {
  const index = Math.min(Math.floor(Math.random() * 3), testimonials.length)
  return testimonials[index]
}
